var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.45361 7.74463C4.9537 7.11954 3.2036 2.49472 6.2036 1.49472C8.51273 0.72501 10.97 3.11505 12.5494 5.30171C13.101 6.06536 14.3228 6.07433 14.8771 5.31267C16.8679 2.57725 20.0179 -0.315814 22.4538 2.12004C25.4538 5.12004 21.2038 7.11977 18.7038 7.74463",
    stroke: "#00CE00",
    strokeWidth: 2.40741,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 13.9941H2.40732C1.74253 13.9941 1.20361 13.4552 1.20361 12.7904V8.94784C1.20361 8.28306 1.74253 7.74414 2.40732 7.74414H24.9999C25.6647 7.74414 26.2036 8.28306 26.2036 8.94784V12.7904C26.2036 13.4552 25.6647 13.9941 24.9999 13.9941Z",
    stroke: "#00CE00",
    strokeWidth: 2.40741,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7036 25.8691V7.74414",
    stroke: "#00CE00",
    strokeWidth: 2.40741,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.32861 13.9941V24.6654C4.32861 25.3302 4.86753 25.8691 5.53232 25.8691H21.2499C21.9147 25.8691 22.4536 25.3302 22.4536 24.6654V13.9941",
    stroke: "#00CE00",
    strokeWidth: 2.40741,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftIcon);
export default __webpack_public_path__ + "static/media/giftIcon.a22d61cb52c8a167fd09ae294edff96c.svg";
export { ForwardRef as ReactComponent };